import { CombinedUnit } from '@/__generated__/types';

export const UNIT_LABEL: Record<CombinedUnit, string> = {
  [CombinedUnit.KilowattHours]: 'kWh',
  [CombinedUnit.CubicMeters]: 'm³',
  [CombinedUnit.KilogramsCo2Equivalent]: 'kg CO₂e',
  [CombinedUnit.Eur]: '€',
  [CombinedUnit.KilowattHoursPerSquareMeter]: 'kWh/m²',
};
